<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.purchaseChanges'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.order.images" v-if="row.order != null" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.order != null">
              {{ row.order.serialNo }}
            </span>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="order.customerName"
          :title="$t('menu.customers')"
          min-width="100"
        /> -->
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.order != null">
              {{ row.order.productNo }}
              <div class="font10">
                {{ row.order.color }} {{ row.order.size }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.order != null">
              {{ row.order.quantity }}<span>{{ row.order.unit }}</span>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="oldValue"
          :title="'原成交单价'"
          min-width="90px"
        >
          <template v-slot="{ row }">
            {{ row.oldValue | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="newValue"
          :title="'新成交单价'"
          min-width="90px"
        >
          <template v-slot="{ row }">
            {{ row.newValue | currency }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="applyName"
          :title="$t('allocate.applyName')"
          min-width="80"
        />
        <vxe-table-column
          field="applyAt"
          :title="$t('allocate.applyAt')"
          min-width="110"
        />
        <vxe-table-column
          field="applyRemark"
          :title="$t('allocate.applyRemark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.applyRemark" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="acceptName"
          :title="$t('allocate.acceptName')"
          min-width="80"
        />
        <vxe-table-column
          field="acceptAt"
          :title="$t('allocate.acceptAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span v-if="row.acceptAt != null">{{ row.acceptAt }}</span>
            <span v-if="row.rejectAt != null">{{ row.rejectAt }}</span>
            <div class="font10" v-if="row.rejectAt != null">
              {{ $t("allocate.rejectReason") }}:
              <raw-html-limit-number :content="row.rejectReason" :number="12" />
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row }">
            <el-button
              v-if="row.acceptAt == null && row.rejectAt == null"
              type="text"
              size="mini"
              @click="agree(row)"
              >{{ $t("verifyTypes.agree") }}</el-button
            >
            <el-button
              v-if="row.acceptAt == null && row.rejectAt == null"
              type="text"
              size="mini"
              @click="reject(row)"
              >{{ $t("verifyTypes.reject") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('action.reject')"
      :close-on-click-modal="false"
      :visible.sync="rejectDF"
      width="30%"
    >
      <el-form ref="rejectObjForm" :model="rejectObj">
        <el-form-item
          :prop="'rejectReason'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('verify.comment2')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="rejectObj.rejectReason"
            :placeholder="$t('verify.comment2')"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="rejectSubmitDoing"
          size="small"
          @click="rejectSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rejectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import ThumbnailText from "@/components/ThumbnailText";
import PurchaseChange from "@/api/purchaseChange.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    ThumbnailText,
  },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("verify.dealType"),
            items: [
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { dealType: "no" },
              },
              {
                label: this.$t("verifyInfos.agree"),
                key: "agree",
                condition: { dealType: "agree" },
              },
              {
                label: this.$t("verifyInfos.reject"),
                key: "reject",
                condition: { dealType: "reject" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        serialNo: null,
        productNo: null,
        color: null,
        size: null,
        customerName: null,
      },
      sorter: {
        sortBy: "purchaseChanges_id",
        sortIndicator: "desc",
      },
      //
      row: null,
      rejectDF: false,
      rejectObj: {
        rejectReason: null,
      },
      rejectSubmitDoing: false,
    };
  },

  created() {
    const self = this;
  },
  methods: {
    //
    reject(row) {
      const self = this;
      self.row = row;
      self.rejectObj.rejectReason = null;
      self.rejectSubmitDoing = false;
      self.rejectDF = true;
    },
    rejectSubmit() {
      const self = this;
      self.$refs.rejectObjForm.validate((valid) => {
        if (valid) {
          self.rejectSubmitDoing = true;
          PurchaseChange.reject(self.row.id, self.rejectObj).then(function (
            res
          ) {
            self.rejectSubmitDoing = false;
            self.rejectDF = false;
            if (res.status === 200) {
              self.sysError(res.data);
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    agree(row) {
      const self = this;
      PurchaseChange.accept(row.id).then(function (res) {
        if (res.status === 200) {
          self.sysError(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    dataProvider(params) {
      return PurchaseChange.acceptSearch(params);
    },
  },
};
</script>
